// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PageLayout from "../../layoutcontainers/PageLayout";
import { useMaterialUIController } from "../../context";
import logo from "../../assest/images/logo.jpg";
import bgImage from "../../assest/LoginBgImage.svg";

function SigninLayout({ header, title, description, illustration, children }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <PageLayout background="#110072" height="100vh" showNavbar disableFooter>
      {/* Blue Outer Layout */}
      <Box
        sx={{
          backgroundColor: "#110072", // Blue color
          width: "100%",
          height: "100vh", // Full viewport height
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem", // Optional spacing
        }}
      >
        {/* Inner Layout with Background Image */}
        <Box
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: "100%",
            borderRadius: "12px", // Optional to match design
            overflow: "hidden", // Ensure no overflow
          }}
        >
          {/* Login Content */}
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              height: "100%",
            }}
          >
            <Grid
              xs={12}
              sm={8}
              md={6}
              lg={4}
              xl={3}
              sx={{ mx: "auto", width: "400px" }}
            >
              <Box display="flex" justifyContent="center" mb={4}>
                <img
                  src={logo}
                  alt="Company Logo"
                  style={{
                    width: "200px",
                    height: "100px",
                  }}
                />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                // textAlign="center"
                sx={{
                  backgroundColor: darkMode
                    ? "rgba(0, 0, 0)"
                    : "rgba(255, 255, 255)",
                  padding: "2rem",
                  borderRadius: "30px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                {/* Logo */}

                {/* Title */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  mb={3}
                >
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color={darkMode ? "white" : "black"}
                  >
                    {title}
                  </Typography>
                  {description && (
                    <Typography
                      //   variant="body1"
                      color={darkMode ? "white" : "black"}
                      sx={{ fontSize: "24px", fontWeight: "bold" }}
                      mt={1}
                    >
                      {description}
                    </Typography>
                  )}
                </Box>

                {/* Children (Content) */}
                <Box width="100%" mt={2}>
                  {children}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </PageLayout>
  );
}

// Typechecking props for the SigninLayout
SigninLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string,
};

export default SigninLayout;
